// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3Tog3","header":"Messages_header__1xT61"};